import ChatInput from './chatInput';

export default ChatInput;
